import React, { useEffect, useState } from 'react';
import formatFileURL from './formatUrl';
import { AWS_File_URL, UPLOAD_ROOT_PATH } from '../../utils/Constants';
const UploadSignatureFile = ({isAssessmentReview, fileInputRef, formik, setShowIp, readOnly=false, readOnlyData, setIsSig, isCancel, from, removeSignature}) => {
  const [dragActive, setDragActive] = useState(false);
  const [image, setImage] = useState(null);
  const [readImage, setReadImage] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [localImage,setLocalImage] = useState(null) 
  useEffect(() => {
    if(isCancel){
      setImage(null);
      setShowIp(null);
    }
  },[isCancel])

  useEffect(() => {
    if(image && from == 'quiz'){
      setLocalImage(image)
      // localStorage.setItem('localImage',JSON.stringify(image))
    }
  },[image,from])
  useEffect(() => {
    if (readOnly && readOnlyData) {
      setImageLoading(true);
      setImageError(false);
      
      // var readImage = readOnlyData?.student_signature?.startsWith("http") || readOnlyData?.student_signature?.startsWith("https")
      //   ? zipURL !== ""
      //     ? zipURL + readOnlyData?.student_signature?.replace(`${UPLOAD_ROOT_PATH}/`, "").replace("public/", "").replace(/https?:\/\//, "")
      //     : readOnlyData?.student_signature?.replace(`${UPLOAD_ROOT_PATH}/`, "").replace("public/", "").replace(/https?:\/\//, "")
      //   : zipURL + (BASE_URL?.replace(/https?:\/\//, "") || "") +
      //     (readOnlyData?.student_signature?.replace(`${UPLOAD_ROOT_PATH}/`, "").replace("public/", "").startsWith("/") ? "" : "/") +
      //     readOnlyData?.student_signature?.replace(`${UPLOAD_ROOT_PATH}/`, "").replace("public/", "");

      var readImage;
      if (
        "fileUploadedFrom" in readOnlyData &&
        readOnlyData?.fileUploadedFrom === "1" &&
        !readOnlyData?.signature?.startsWith("https://")
      ) {
        readImage =
          from === "quiz"
            ? AWS_File_URL + readOnlyData?.signature
            : readOnlyData?.student_signature;
      } else {
        const filePath =
          from === "quiz"
            ? readOnlyData?.signature
            : readOnlyData?.student_signature;

        readImage = formatFileURL(filePath);
      }
      
     
      // Create a new image object to test the loading
      if(readImage && !readImage.endsWith('undefined')){
        const img = new Image();
        
        img.onload = () => {
          setImageLoading(false);
          setReadImage(readImage);
          if(from == 'quiz'){
            setLocalImage(null)
          }
          localStorage.removeItem('localImage')
        };
        
        img.onerror = () => {
          setImageLoading(false);
          setImageError(true);
        };
        img.src = readImage;
      }
    }
  }, [readOnly, readOnlyData]);
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFiles(e.dataTransfer.files);
      formik && formik.setFieldValue('student_signature', e.dataTransfer.files[0]);
      setIsSig(e.dataTransfer.files[0]);
    }
  };
  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      // setImageLoading(true);
      handleFiles(e.target.files);
      formik && formik.setFieldValue('student_signature', e.target.files[0]);
      setIsSig(e.target.files[0]);
    }
  };
  const handleFiles = (files) => {
    setShowIp(true);
    const file = files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  
  return (
    <div className="max-w-md mw-100 position-relative signature-pad-outer p-4 border border-gray-300 rounded-lg">
      {(image || readOnly) ? (
        <>
          {
            <>
              {(imageLoading || localImage) && !imageError && (
                <div className="text-center p-4">
                  <div className="spinner-border text-primary" role="status"> 
                  </div>
                </div>
              )}
              {imageError && (
                <div className="text-center text-danger p-4">
                    Failed to load image. Please try again.
                </div>
              )}
              {!imageLoading && !imageError && !localImage && (
                <>
                <img 
                src={readOnly ? readImage : from == 'quiz' ? localImage : image} 
                style={{color: '#467FCF', maxHeight: "175px"}} 
                alt="Uploaded" 
                className="max-w-full m-auto d-block object-contain" 
              />
               <div 
                className={`${!isAssessmentReview && readOnly && from == 'quiz' && readOnlyData?.signature_type == 1 ? '' : readOnly ? 'd-none' : ''} position-absolute`}
                style={{
                  cursor: readOnly && from == 'quiz' ? "pointer" : readOnly ? "" : 'pointer',
                  color: '#467FCF',
                  top: '6px',
                  right:'10px'
                }} 
                onClick={() => {
                  if(from == 'quiz'){
                    setImage("")
                    removeSignature(1)
                    setShowIp(false)
                    setReadImage("")
                  }else{
                    setImage(null);
                    setShowIp(false);
                    formik && formik.setFieldValue('student_signature', null);
                    setIsSig(null);
                  }
                }}
              >
                Remove Uploaded Image<i className='fal ml-2 fa-trash-alt'></i>
              </div>
              </>
              
              )}
            </>}
        </>
      ) : (
        <label 
          htmlFor="file-upload" 
          className={`border-2 border-dashed rounded-lg p-6 text-center ${
            dragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
          }`}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <i className='fal fa-upload' style={{fontSize: '48px', color: '#467FCF'}}></i>
          <p className="mb-0 text-gray-600 mt-3">
            To upload your signature, Drop your file here, or{' '}
            <label 
              htmlFor="file-upload" 
              className="font-medium fw-bold text-blue-600 hover:underline cursor-pointer"
              style={{color:"var(--button-color)", cursor: 'pointer'}}
            >
              click here to browse
            </label>
          </p>
          <p className="mt-1 text-xs" style={{color:"var(--button-color)"}}>
            Supported Files: JPG and PNG
          </p>
          <input
            id="file-upload"
            name="file-upload"
            type="file"
            className="d-none"
            ref={fileInputRef}
            onChange={handleChange}
            accept=".jpg,.png"
          />
        </label>
      )}
    </div>
  );
};
export default UploadSignatureFile;